import React, { useState, useEffect } from "react";
import BASE_URL from "../../config";

export default function News() {
  const [form, setForm] = useState({
    title: "",
    date: "",
    description: "",
  });

  const [news, setNews] = useState([]);

  // 🔄 Fetch News
  useEffect(() => {
    const fetchNews = () => {
      fetch(`${BASE_URL}/api/getNews.php?t=${Date.now()}`)
        .then((res) => res.json())
        .then((data) => setNews(data))
        .catch((err) => console.error(err));
    };

    fetchNews();

    const interval = setInterval(fetchNews, 5000);

    return () => clearInterval(interval);
  }, []);

  // ✏️ Handle input
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  // 🚀 Submit
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", form.title);
    formData.append("date", form.date);
    formData.append("description", form.description);

    fetch(`${BASE_URL}/api/addNews.php`, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.text())
      .then((msg) => {
        alert(msg);

        // clear form
        setForm({
          title: "",
          date: "",
          description: "",
        });
      });
  };

  // ❌ Delete
  const deleteNews = (id) => {
    fetch(`${BASE_URL}/api/deleteNews.php?id=${id}`)
      .then((res) => res.text())
      .then((msg) => alert(msg));
  };

  return (
    <div className="news-page">
      {/* FORM */}
      <div className="form-container">
        <h2>➕ માહિતી ઉમેરો</h2>

        <form onSubmit={handleSubmit} className="form">
          <input
            type="text"
            name="title"
            placeholder="શીર્ષક"
            value={form.title}
            onChange={handleChange}
            required
          />

          <input
            type="date"
            name="date"
            placeholder="તારીખ"
            value={form.date}
            onChange={handleChange}
            required
          />

          <textarea
            name="description"
            placeholder="વિગત"
            value={form.description}
            onChange={handleChange}
            required
          />

          <button type="submit">save</button>
        </form>
      </div>

      {/* TABLE */}
      <div className="table-card">
        <h2> માહિતી યાદી</h2>

        <table className="news-table">
          <thead>
            <tr>
              <th>ક્રમ</th>
              <th>તારીખ</th>
              <th>શીર્ષક</th>
              <th>વિગત</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {news.length === 0 ? (
              <tr>
                <td colSpan="5">કોઈ માહિતી નથી</td>
              </tr>
            ) : (
              news.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.date}</td>
                  <td>{item.title}</td>
                  <td>{item.description}</td>
                  <td>
                    <button
                      style={{
                        background: "#b41212",
                        color: "#fff",
                        border: "none",
                        padding: "5px 0px",
                        cursor: "pointer",
                        width: "100px",
                      }}
                      onClick={() => deleteNews(item.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
